import { render } from "./FilterSmallInput.vue?vue&type=template&id=96d454ec&ts=true"
import script from "./FilterSmallInput.vue?vue&type=script&lang=ts"
export * from "./FilterSmallInput.vue?vue&type=script&lang=ts"

import "./FilterSmallInput.vue?vue&type=style&index=0&id=96d454ec&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__